import request from '@utils/request'

const THEME_BASE_URL = '/api_v3/studio/themes'
/**
 * 获取主题列表
 * @param {*} params 
 * @returns 
 */
export const getThemeList = params => request({
    url: THEME_BASE_URL,
    method: 'get',
    params,
})

export const getThemeById = id => request({
    url: `${THEME_BASE_URL}/${id}`,
    method: 'get',
})

export const getDefaultTheme = () => request({
    url: `${THEME_BASE_URL}/default`,
    method: 'get',
})

/**
 *  新建主题
 * @param {*} data 
 * @returns 
 */
export const addTheme = data => request({
    url: THEME_BASE_URL,
    method: 'post',
    data,
})

/**
 * 更新主题
 * @param {*} id 主题id
 * @param {*} data 更新的数据
 * @returns 
 */
export const updateTheme = (id, data) => request({
    url: `${THEME_BASE_URL}/${id}`,
    method: 'PATCH',
    data,
})

/**
 * 删除主题
 * @param {*} id 主题id
 * @returns 
 */
export const deleteTheme = id => request({
    url: `${THEME_BASE_URL}/${id}`,
    method: 'delete',
})

/**
 * 获取已选中的主题详情
 * @param {*} params 
 * @returns 
 */
export const getSelectedTheme = params => request({
    url: `${THEME_BASE_URL}/bySelected`,
    method: 'get',
    params,
})

/**
 * 选中主题
 * @param {*} id 
 * @returns 
 */
export const setSelectedTheme = id => request({
    url: `/api_v3/studio/themeSelects/${id}`,
    method: 'post',
})

/**
 * 更新主题
 * @param {*} id 主题id
 * @param {*} data 
 * @returns 
 */
export const updateThemeTitle = (id, data) => request({
    url: `${THEME_BASE_URL}/${id}/editThemeTitle`,
    method: 'PATCH',
    data,
})
